import { Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import LandingPage from './pages/LandingPage';
import DashboardPage from './pages/DashboardPage';
import HoldingsPage from './pages/HoldingsPage';
import TradesPage from './pages/TradesPage';
import DividendsPage from './pages/DividendsPage';
import DepositsPage from './pages/DepositsPage';
import AnalysisPage from './pages/AnalysisPage';
import RiskPage from './pages/RiskPage';
import './App.css';

function PrivateRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function App() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="app">
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />}
        />
        <Route
          path="/register"
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <RegisterPage />}
        />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Layout>
                <DashboardPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/holdings"
          element={
            <PrivateRoute>
              <Layout>
                <HoldingsPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/trades"
          element={
            <PrivateRoute>
              <Layout>
                <TradesPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/dividends"
          element={
            <PrivateRoute>
              <Layout>
                <DividendsPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/deposits"
          element={
            <PrivateRoute>
              <Layout>
                <DepositsPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/analysis"
          element={
            <PrivateRoute>
              <Layout>
                <AnalysisPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/risk"
          element={
            <PrivateRoute>
              <Layout>
                <RiskPage />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Analytics />
    </div>
  );
}

export default App;
